// extracted by mini-css-extract-plugin
module.exports = {"progress":"ledger_progress__2Jo2w","separator":"ledger_separator__11UcR"};